import React from "react";

import { Stack } from "@churchofjesuschrist/eden-stack";

import StyledHtmlFragment from "../../generic/styled-html-fragment/styled-html-fragment";

const HelpArticleDisplay = ({ article, showTitle = false, ...others }) => (
  <Stack {...others}>
    {article.title && showTitle ? <h1>{article.title}</h1> : null}
    <StyledHtmlFragment content={article.contents} />
  </Stack>
);

export default HelpArticleDisplay;
